module.exports = __webpack_public_path__ + "img/chat_emoticon_tipos_22.png?975e9de84d97bbe1163ba24037601152";